import React from 'react'
import { Box, Typography, Checkbox } from '@mui/material'
import FavoriteIcon from '@mui/icons-material/Favorite';


function HeartListItem({text, onChange}) {
    return (
        <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', marginTop: '10px'}}>
            <FavoriteIcon sx={{fontSize: '40px'}} />
            <Typography sx={{marginLeft: '10px', flexGrow: 1}}>{text}</Typography>
            <Checkbox sx={{transform: "scale(1.5)"}}  onChange={onChange}></Checkbox>
        </Box>
    )
}

export default HeartListItem